<p-dialog [(visible)]="visible" 
          [modal]="true" 
          [header]="editingItem ? 'Edit Experience' : 'Add Experience'" 
          [style]="{width: '94vw', maxWidth: '580px'}"
          [draggable]="false"
          [resizable]="false"
          styleClass="education-modal"
          appendTo="body"
          (onHide)="closeDialog()">
    
    <form *ngIf="tempExperienceForm" [formGroup]="tempExperienceForm" class="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4 pb-2 px-1">
        <!-- Institution Name -->
        <div class="space-y-1.5 md:col-span-2">
            <label class="block text-[#1A1A1A] text-sm lg:text-15 font-medium">Institution/Company Name <span class="text-red-500">*</span></label>
            <input type="text" 
                   formControlName="institution_name" 
                   class="block w-full text-sm border border-gray-300 rounded-lg p-3 outline-none focus:border-primary transition-all placeholder:text-gray-400" 
                   placeholder="Ex: Greenfield International School">
            <div *ngIf="tempExperienceForm.get('institution_name')?.invalid && (tempExperienceForm.get('institution_name')?.dirty || tempExperienceForm.get('institution_name')?.touched)" 
                 class="text-red-500 text-[11px] mt-0.5 ml-1">
                Institution name is required.
            </div>
        </div>

        <!-- Location -->
        <div class="space-y-1.5">
            <label class="block text-[#1A1A1A] text-sm lg:text-15 font-medium">Location <span class="text-red-500">*</span></label>
            <input type="text" 
                   formControlName="location" 
                   class="block w-full text-sm border border-gray-300 rounded-lg p-3 outline-none focus:border-primary transition-all placeholder:text-gray-400" 
                   placeholder="Ex: Dubai, UAE">
            <div *ngIf="tempExperienceForm.get('location')?.invalid && (tempExperienceForm.get('location')?.dirty || tempExperienceForm.get('location')?.touched)" 
                 class="text-red-500 text-[11px] mt-0.5 ml-1">
                Location is required.
            </div>
        </div>

        <!-- Employment Type -->
        <div class="space-y-1.5">
            <label class="block text-[#1A1A1A] text-sm lg:text-15 font-medium">Employment Type <span class="text-red-500">*</span></label>
            <div class="w-full border_dropdown">
                <p-dropdown styleClass="w-full text-sm py-0.5" 
                            [options]="constants?.experienceTypeObjArray" 
                            formControlName="type" 
                            optionLabel="name" 
                            optionValue="value" 
                            placeholder="Select Type"
                            appendTo="body" />
            </div>
        </div>

        <!-- Subjects -->
        <div class="space-y-1.5 md:col-span-2">
            <label class="block text-[#1A1A1A] text-sm lg:text-15 font-medium">Subjects Taught <span class="text-red-500">*</span></label>
            <div class="w-full border_dropdown multi_dropdown">
                <p-multiSelect styleClass="w-full text-sm" 
                               [options]="subjects" 
                               formControlName="subjects" 
                               optionLabel="name" 
                               optionValue="id" 
                               placeholder="Select Subjects"
                               [selectionLimit]="5"
                               [maxSelectedLabels]="5"
                               [filter]="true"
                               appendTo="body" />
                <div *ngIf="tempExperienceForm.get('subjects')?.invalid && (tempExperienceForm.get('subjects')?.dirty || tempExperienceForm.get('subjects')?.touched)" class="text-red-500 text-[11px] mt-0.5 ml-1">
                    <span *ngIf="tempExperienceForm.get('subjects')?.hasError('required')">At least one subject is required.</span>
                    <span *ngIf="tempExperienceForm.get('subjects')?.hasError('maxlength')">You can select a maximum of 5 subjects.</span>
                </div>
            </div>
        </div>

        <!-- Start Date -->
        <div class="space-y-1.5">
            <label class="block text-[#1A1A1A] text-sm lg:text-15 font-medium">Start Date <span class="text-red-500">*</span></label>
            <div class="flex gap-2">
                <div class="flex-1 border_dropdown">
                    <p-dropdown styleClass="w-full text-sm py-0.5" [options]="constants.months" formControlName="start_month" optionLabel="name" optionValue="name" placeholder="Month" appendTo="body" />
                </div>
                <div class="flex-1 border_dropdown">
                    <p-dropdown styleClass="w-full text-sm py-0.5" [options]="yearList" formControlName="start_year" optionLabel="name" optionValue="value" placeholder="Year" appendTo="body" />
                </div>
            </div>
        </div>

        <!-- End Date / Currently Working -->
        <div class="space-y-1.5">
            <div class="flex items-center justify-between">
                <label class="block text-[#1A1A1A] text-sm lg:text-15 font-medium">End Date</label>
                <div class="flex items-center gap-2">
                    <p-checkbox formControlName="is_currently_working" [binary]="true" inputId="modal_is_currently_working" />
                    <label for="modal_is_currently_working" class="text-xs text-gray-500 cursor-pointer select-none">I currently work here</label>
                </div>
            </div>
            <div class="flex gap-2" *ngIf="!tempExperienceForm.get('is_currently_working')?.value">
                <div class="flex-1 border_dropdown">
                    <p-dropdown styleClass="w-full text-sm py-0.5" [options]="constants.months" formControlName="end_month" optionLabel="name" optionValue="name" placeholder="Month" appendTo="body" />
                </div>
                <div class="flex-1 border_dropdown">
                    <p-dropdown styleClass="w-full text-sm py-0.5" [options]="yearList" formControlName="end_year" optionLabel="name" optionValue="value" placeholder="Year" appendTo="body" />
                </div>
            </div>
            <div class="h-[38px] flex items-center px-3 bg-gray-50 rounded-lg text-green-600 text-xs font-bold" *ngIf="tempExperienceForm.get('is_currently_working')?.value">
                Present
            </div>
            <div *ngIf="tempExperienceForm.hasError('dateRange') && (tempExperienceForm.get('end_year')?.dirty || tempExperienceForm.get('end_year')?.touched || tempExperienceForm.get('end_month')?.dirty || tempExperienceForm.get('end_month')?.touched)" 
                 class="text-red-500 text-[11px] mt-0.5 ml-1">
                End date cannot be earlier than start date.
            </div>
        </div>

        <!-- Teaching Summary -->
        <div class="space-y-1.5 md:col-span-2">
            <label class="block text-[#1A1A1A] text-sm lg:text-15 font-medium">Teaching Summary <span class="text-red-500">*</span></label>
            <textarea formControlName="teaching_summary" 
                      rows="3"
                      class="block w-full text-sm border border-gray-300 rounded-lg p-3 outline-none focus:border-primary transition-all placeholder:text-gray-400 resize-none" 
                      placeholder="Describe your key achievements and responsibilities..."></textarea>
            <div *ngIf="tempExperienceForm.get('teaching_summary')?.invalid && (tempExperienceForm.get('teaching_summary')?.dirty || tempExperienceForm.get('teaching_summary')?.touched)" 
                 class="text-red-500 text-[11px] mt-0.5 ml-1">
                Teaching summary is required.
            </div>
        </div>

        <!-- Document Upload -->
        <div class="space-y-1.5 md:col-span-2 pt-1">
            <div class="flex items-center gap-1.5">
                <label class="block text-[#1A1A1A] text-sm font-medium">Supporting Document (Optional)</label>
                <span [pTooltip]="'Upload certificates or reference letters to strengthen your profile.'" 
                      tooltipPosition="top" 
                      appendTo="body"
                      tooltipStyleClass="education-tooltip"
                      class="flex items-center cursor-help">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </span>
            </div>
            <input id="modal_exp_document_upload" type="file" class="hidden" (change)="updateExperienceDocument($event)">
            <div *ngIf="!tempExperienceForm.get('document')?.value" 
                 class="border border-dashed border-gray-200 rounded-lg p-3 bg-gray-50/30 flex items-center justify-between transition-colors hover:bg-gray-50">
                <p class="text-[11px] text-gray-500">Max 20MB (JPG, PNG)</p>
                <label for="modal_exp_document_upload" class="cursor-pointer px-6 py-1.5 bg-primary text-white text-xs rounded-lg hover:bg-blue-600 transition-colors shadow-sm font-bold">Upload</label>
            </div>
            <div *ngIf="tempExperienceForm.get('document')?.value" 
                 class="flex items-center gap-3 border border-gray-200 rounded-lg p-2.5 bg-white">
                <div class="w-10 h-10 rounded overflow-hidden shadow-sm border border-gray-100 flex items-center justify-center bg-gray-50 text-primary">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                </div>
                <div class="flex-1"><p class="text-[11px] text-gray-600 truncate font-medium">Document Attached</p></div>
                <label for="modal_exp_document_upload" class="text-[#2ECC71] text-xs font-bold cursor-pointer hover:underline">Change</label>
            </div>
        </div>

        <!-- Modal Footer -->
        <div class="flex items-center justify-end gap-6 pt-5 pb-1 md:col-span-2">
            <button type="button" 
                    (click)="closeDialog()" 
                    class="text-gray-500 hover:text-gray-800 transition-colors font-medium text-15"
                    [disabled]="isBtnLoading">
                Cancel
            </button>
            <button type="button" 
                    (click)="saveExperienceItem()" 
                    class="px-8 py-2.5 bg-primary hover:bg-blue-600 text-white rounded-lg transition-all font-bold shadow-sm text-sm lg:text-15"
                    [disabled]="isBtnLoading">
                <span class="inline-block" *ngIf="isBtnLoading">
                    <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-inherit" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"> 
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle> 
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path> 
                    </svg>
                </span>
                Save
            </button>
        </div>
    </form>
</p-dialog>
